import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background } = colors;

export default makeStyles(() => ({
  "@keyframes slideUp": {
    from: {
      transform: "translateY(70vh)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },

  container: {
    position: "fixed",
    width: "100%",
    maxWidth: 480,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "12px 20px 20px 20px",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
    backgroundColor: background?.default || "#FDFCF8",
    animation: "$slideUp 0.6s ease-out",
    maxHeight: "85vh",
    overflowY: "auto",
    zIndex: 1300,
  },

  dragHandle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#D0CBC1",
    marginBottom: 20,
    flexShrink: 0,
  },

  containerChildren: {
    width: "100%",
    height: "auto",
    paddingBottom: 8,
  },
}));
